import classNames from "./OverflowPopover.module.css";
import { IoEllipsisHorizontal } from "react-icons/io5";
import SettingsDialog, {
  SettingsDialogProps,
} from "../../common/dialogs/SettingsDialog";
import { useLocalParticipant } from "@livekit/components-react";
import { useMemo, useState } from "react";
import { LocalAudioTrack, LocalVideoTrack } from "livekit-client";
import { useRoom } from "../../context/room/room";
import Button from "../../common/Button";
import Popover from "../../common/Popover";
import { useIsMobile } from "../../../hooks/layout";
import { useMeeting } from "../../../hooks/meeting";
import { Room } from "../../../hooks/api";

export default function OverflowPopover(props: {
  toggleOverlay: () => void;
  className?: string;
  room: Room;
}) {
  const { organization } = useRoom();

  const {
    microphoneTrack: microphoneTrackPublication,
    cameraTrack: cameraTrackPublication,
  } = useLocalParticipant();
  const localAudioTrack = useMemo(() => {
    return microphoneTrackPublication?.audioTrack as
      | LocalAudioTrack
      | undefined;
  }, [microphoneTrackPublication]);
  const localVideoTrack = useMemo(() => {
    return cameraTrackPublication?.videoTrack as LocalVideoTrack | undefined;
  }, [cameraTrackPublication]);

  const hiddenSettingsCategories: SettingsDialogProps["hiddenCategories"] =
    useMemo(() => {
      if (!organization?.voice_translation_enabled) {
        return ["voice-avatar", "text-translation"];
      }
      return ["text-translation"];
    }, [organization]);

  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  const [, setMeeting] = useMeeting();

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger={
        <Button
          color={open ? "white" : "gray"}
          borderColor={open ? "primary" : "dark-gray"}
          backgroundColor="black"
          className={props.className}
        >
          <IoEllipsisHorizontal />
        </Button>
      }
      content={
        <div className={classNames.Content}>
          {!isMobile ? (
            <SettingsDialog
              trigger={<button>Settings</button>}
              hiddenCategories={hiddenSettingsCategories}
              localAudioTrack={localAudioTrack}
              localVideoTrack={localVideoTrack}
            />
          ) : (
            <>
              <SettingsDialog
                trigger={<button>Audio</button>}
                localAudioTrack={localAudioTrack}
                initialSelectedSetting="audio"
              />
              <SettingsDialog
                trigger={<button>Video</button>}
                localVideoTrack={localVideoTrack}
                initialSelectedSetting="video"
              />
              <SettingsDialog
                trigger={<button>Voice avatar</button>}
                initialSelectedSetting="voice-avatar"
              />
              <button
                onClick={() =>
                  setMeeting((prevState) => ({
                    ...prevState,
                    layout: {
                      ...prevState.layout,
                      panels: {
                        ...prevState.layout.panels,
                        participants: !prevState.layout.panels.participants,
                      },
                    },
                  }))
                }
              >
                Captions
              </button>
            </>
          )}
          {/* @ts-expect-error Experimental */}
          {!!window.documentPictureInPicture && (
            <button onClick={props.toggleOverlay}>Overlay</button>
          )}
        </div>
      }
      align={!isMobile ? "start" : "end"}
    />
  );
}
